<div class="reservation-details-modal">
  <div class="reservation-details-header">
    <h4 class="modal-title">
      {{ title }}
    </h4>

    <button
      type="button"
      class="reservation-details-close"
      aria-label="Close dialog"
      (click)="cancel()"
    >
      &times;
    </button>
  </div>

  <app-alert></app-alert>

  <div class="reservation-details-body">
    <div
      class="table-wrapper mat-elevation-z8"
      id="entities"
      *ngIf="reservationCustomers && reservationCustomers.length > 0"
    >
      <table
        mat-table
        [dataSource]="filteredReservations()"
        class="styled-table"
        aria-describedby="page-heading"
      >
        <ng-container matColumnDef="reservationNumber">
          <th mat-header-cell *matHeaderCellDef>
            <span [translate]="'bookingApp.reservation.reservationNumber'">
              Reservation number
            </span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            (click)="openScheduleAppointment(element.reservationnumber)"
          >
            {{ element.reservationnumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            <span [translate]="'bookingApp.reservation.name'">Name</span>
          </th>
          <td mat-cell *matCellDef="let element" (click)="openUserNavigation(element.technouserid)">
            {{ element.technousers }}
          </td>
        </ng-container>

        <ng-container matColumnDef="startReservationLocalDate">
          <th mat-header-cell *matHeaderCellDef>
            <span [translate]="'bookingApp.reservation.startReservationLocalDate'">
              Start Reservation Local Date
            </span>
          </th>
          <td mat-cell *matCellDef="let element">
            {{
              element.startreservationlocaldate
                | date: 'dd/MM/yyyy HH:mm'
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="endReservationLocalDate">
          <th mat-header-cell *matHeaderCellDef>
            <span [translate]="'bookingApp.reservation.endReservationLocalDate'">
              End Reservation Local Date
            </span>
          </th>
          <td mat-cell *matCellDef="let element">
            {{
              element.endreservationlocaldate
                | date: 'dd/MM/yyyy HH:mm'
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="duration">
          <th mat-header-cell *matHeaderCellDef>
            <span [translate]="'bookingApp.reservation.duration'">Duration</span>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.duration }}</td>
        </ng-container>

        <ng-container matColumnDef="utilities">
          <th mat-header-cell *matHeaderCellDef>
            <span [translate]="'bookingApp.reservation.utilities'">Utilities</span>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.utilities }}</td>
        </ng-container>

        <ng-container matColumnDef="resources">
          <th mat-header-cell *matHeaderCellDef>
            <span [translate]="'bookingApp.reservation.resources'">Resources</span>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.resourcename }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            <span [translate]="'bookingApp.reservation.status'">Status</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <button
              type="button"
              class="btn reservation-details-cancel-btn"
              (click)="onStatusCancel(element, element.technouserid)"
            >
              <span [translate]="'bookingApp.reservation.cancel'">Otkaži</span>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>

  <div
    class="reservation-details-footer"
    *ngIf="reservationCustomers && reservationCustomers.length > 0"
  >
    <button
      type="button"
      class="btn reservation-details-back-btn"
      (click)="cancel()"
      [translate]="'openItems.closePayment'"
    >
      Odustani
    </button>
    <button
      type="button"
      class="btn reservation-details-primary-btn"
      (click)="openNewScheduleAppointment()"
    >
      <span [translate]="'bookingApp.reservation.newReservation'">
        Kreiraj novu rezervaciju
      </span>
    </button>
  </div>
</div>
